import type { OperatorOption, ColumnType } from '../types';

const NUMBER_OPERATORS: OperatorOption[] = [
  { value: 'equals', label: 'ist gleich' },
  { value: 'notEqual', label: 'ist ungleich' },
  { value: 'greaterThan', label: 'größer als' },
  { value: 'lessThan', label: 'kleiner als' },
  { value: 'greaterThanOrEqual', label: 'größer oder gleich' },
  { value: 'lessThanOrEqual', label: 'kleiner oder gleich' },
  { value: 'between', label: 'zwischen' },
  { value: 'anyOf', label: 'ist einer von' },
  { value: 'notAnyOf', label: 'ist keiner von' },
  { value: 'empty', label: 'ist leer' },
  { value: 'notEmpty', label: 'ist nicht leer' }
];

const TEXT_OPERATORS: OperatorOption[] = [
  { value: 'equals', label: 'ist gleich' },
  { value: 'notEqual', label: 'ist ungleich' },
  { value: 'contains', label: 'enthält' },
  { value: 'notContains', label: 'enthält nicht' },
  { value: 'startsWith', label: 'beginnt mit' },
  { value: 'endsWith', label: 'endet mit' },
  { value: 'anyOf', label: 'ist einer von' },
  { value: 'notAnyOf', label: 'ist keiner von' },
  { value: 'empty', label: 'ist leer' },
  { value: 'notEmpty', label: 'ist nicht leer' }
];

export function getOperatorsForType(type: ColumnType): OperatorOption[] {
  return type === 'number' ? NUMBER_OPERATORS : TEXT_OPERATORS;
}
